import badges from "@/store/modules/feedback/badges";
import feedback from "@/store/modules/feedback/feedback";
import praiseWall from "@/store/modules/feedback/praise-wall";
import request from "@/store/modules/feedback/request";
import stats from "@/store/modules/feedback/stats";

export default {
    namespaced: true,
    modules: {
        badges,
        feedback,
        praiseWall,
        request,
        stats,
    },
};
